import axiosWithAuth from '../utils/axiosWithAuth';
import { getApiEndpoint } from '../utils/apiConfig';

// Get all repair styles (admin)
export const getAllRepairStyles = async () => {
  try {
    const response = await axiosWithAuth().get(getApiEndpoint('repair-styles/admin'));
    console.log('Repair styles response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching repair styles:', error);
    throw error;
  }
};

// ID'ye göre Repair Style getir
export const getRepairStyle = async (id) => {
  try {
    const response = await axiosWithAuth().get(getApiEndpoint(`repair-styles/${id}`));
    return response.data;
  } catch (error) {
    console.error(`Error fetching repair style ${id}:`, error);
    throw error;
  }
};

// Yeni Repair Style ekle
export const createRepairStyle = async (data) => {
  try {
    const response = await axiosWithAuth().post(getApiEndpoint('repair-styles'), data);
    return response.data;
  } catch (error) {
    console.error('Error creating repair style:', error);
    throw error;
  }
};

// Repair Style güncelle
export const updateRepairStyle = async (id, data) => {
  try {
    const response = await axiosWithAuth().put(getApiEndpoint(`repair-styles/${id}`), data);
    return response.data;
  } catch (error) {
    console.error(`Error updating repair style ${id}:`, error);
    throw error;
  }
};

// Repair Style sil
export const deleteRepairStyle = async (id) => {
  try {
    const response = await axiosWithAuth().delete(getApiEndpoint(`repair-styles/${id}`));
    return response.data;
  } catch (error) {
    console.error(`Error deleting repair style ${id}:`, error);
    throw error;
  }
}; 